export enum AttachmentSaveLocationType{
  DELIVERY= 'DELIVERY',
  CRM = 'CRM'
}
